import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import * as Sentry from '@sentry/vue';
import applyUtilities, { language, LicensePlateMixin } from './cleanUtilities.js';
import get from 'lodash/get';

import Modal from './components/Modal.vue';
import Price from './components/Price.vue';
import IconTextContainer from './components/Layout/IconTextContainer.vue';
import LoadingAnimation from './components/LoadingAnimation.vue';
import NovaDatePicker from './components/NovaDatePicker.vue';
import LicensePlateInput from './components/LicensePlateInput.vue';
import CustomerReviews from './components/CustomerReviews.vue';

export function initializeApp(selector = '#app', components) {
    const app = createApp({
        components,
        mixins: [LicensePlateMixin],
        provide: {
            currentLocale: language,
        },
    });

    Sentry.init({
        app,
        environment: import.meta.env.MODE,
        dsn: 'https://8cfe99549ae519b1ce552b0588e28099@sentry.dmc-gmbh.online/18',
        sendDefaultPii: true,
        integrations: [
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
            Sentry.browserTracingIntegration({
                tracingOrigins: [window.location.hostname, /^\//],
            }),
        ],
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });

    applyUtilities(app);

    app.use(createI18n({
        locale: app.config.globalProperties.$language,
        messages: typeof locales === 'object' ? locales : {},
        fallbackLocale: 'en',
        messageResolver: (obj, path) => get(obj, path, '')?.replaceAll(/@/g, '{\'@\'}') || null,
    }));

    app.component('price', Price);
    app.component('icon-text-container', IconTextContainer);
    app.component('modal', Modal);
    app.component('loading-animation', LoadingAnimation);
    app.component('nova-datepicker', NovaDatePicker);
    app.component('license-plate-input', LicensePlateInput);
    app.component('customer-reviews', CustomerReviews);

    app.mount(selector);

    return app;
}
